<template>
  <v-dialog v-model="dialogStoreManager" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title>Nhập kho ngày {{ currentTime | display_date('DD-MM-YYYY') }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg3 md3 sm3>
            <v-layout row wrap pa-3>
              <v-flex lg4 md4 sm12 pa-0 ma-0 pt-4>
                <v-checkbox label="Auto load" v-model="useBarcodeReader"></v-checkbox>
              </v-flex>
              <v-flex lg4 md4 sm12 pa-0 ma-0 pt-4>
                <v-checkbox label="Vô chủ" v-model="nonameProduct"></v-checkbox>
              </v-flex>
              <v-flex lg4 md4 sm12 pa-0 ma-0 pt-4>
                <v-checkbox label="Xuất khẩu" v-model="invertOrder"></v-checkbox>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field :label="invertOrder ? 'Mã VBI' : 'Mã vận đơn (运单号)'" ref="trancode"
                  v-model="currentItem.TransactionCode" class="input-group--focused" :rules="requireRules"
                  @input="codeChanged" @keyup.enter="manualChanged"></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 mt-1 mb-2 v-if="warningsList.length > 0">
                <v-chip v-for="(warning, index) in warningsList" :key="index" color="red darken-2" text-color="white"
                small class="mr-1 mb-1">
                  {{ warning }}
                </v-chip>
              </v-flex>
              <!-- <v-flex lg12 md12 sm12 pa-0>
                <v-select label="Loại đơn hàng" v-model="selectedOrderType" :items="order_type_list" item-text="name"
                  item-value="value" :disabled="currentItem.OrderID > 0"></v-select>
              </v-flex> -->
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field label='Mã đơn MD' v-model="selectedOrderID" class="input-group--focused" :disabled="currentItem.OrderID > 0"></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-autocomplete label="Khách hàng" v-model="selectedUID" :items="filteredAndSortedCustomers" :item-text="getCustomerText" item-value="ID" :disabled="currentItem.UID > 0" clearable :search-input.sync="searchTerm" no-filter>
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title v-html="highlight(item)"></v-list-item-title>
                  </v-list-item-content>
                </template>
                </v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input v-model="currentItem.NumberOfPack" :decimal="0" label="Số kiện (件数)" class="input-group--focused"></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input v-model="currentItem.Weight" :decimal="1" label="Cân nặng (kg)" class="input-group--focused"></h-currency-input>
              </v-flex>
              <v-flex lg4 md4 sm12 pa-0 v-if="!isEcommerce">
                <h-currency-input v-model="currentItem.Length" :decimal="1" label="Chiều dài (cm)" class="input-group--focused"></h-currency-input>
              </v-flex>
              <v-flex lg4 md4 sm12 pa-0 pl-1 v-if="!isEcommerce">
                <h-currency-input v-model="currentItem.Width" :decimal="1" label="Chiều rộng (cm)" class="input-group--focused"></h-currency-input>
              </v-flex>
              <v-flex lg4 md4 sm12 pa-0 pl-1 v-if="!isEcommerce">
                <h-currency-input v-model="currentItem.Height" :decimal="1" label="Chiều cao (cm)" class="input-group--focused"></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input v-model="currentItem.FeeShip" :decimal="1" label="Phí ship (运费)" class="input-group--focused"></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input v-model="currentItem.FeeFragileGoods" :decimal="1" label="Phí gia cố (加固费)" class="input-group--focused"></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input v-model="currentItem.FeeOther" :decimal="1" label="Phí khác (其他)" class="input-group--focused"></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-textarea v-model="currentItem.StoreCNNote" label="Ghi chú (备注)" class="input-group--focused" rows="2"></v-textarea>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pr-2 pt-2>
                <v-layout row wrap justify-end>
                  <v-btn @click="saveData">Nhập</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg9 md9 sm9>
            <v-layout pl-4 pr-2 pt-12>
              <v-flex lg12 md12 sm12 xs12>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                  :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading"
                  :mobile-breakpoint="100">
                  <template v-slot:item="{ item }">
                    <tr :style="{ 'background-color': item.IsWarning || item.IsFragileGoods || item.IsFoam || item.IsCheck || item.IsGuarantee ? '#f56e6e' : '#ffffff' }">
                      <td>{{ item.ID }}</td>
                      <td>{{ item.TransactionCode }}</td>
                      <td>{{ item.VbiCode }}</td>
                      <td>
                        {{ item.IsFragileGoods ? '打木架' : '' }}
                        <br v-if="item.IsFragileGoods" />
                        {{ item.IsCheck ? '理货' : '' }}
                        <br v-if="item.IsCheck" />
                        {{ item.IsGuarantee ? '保险' : '' }}
                        <br v-if="item.IsGuarantee" />
                        {{ item.IsFoam ? '用气泡膜' : '' }}
                      </td>
                      <td class="text-end">
                        <v-edit-dialog :return-value.sync="item.NumberOfPack" large lazy persistent @save="saveItem({ID: item.ID, NumberOfPack: item.NumberOfPack})">
                          <div>{{ item.NumberOfPack | currency }}</div>
                          <template v-slot:input>
                            <h-currency-input v-model="item.NumberOfPack" :decimal="0" label="Số kiện (件数)" autofocus
                              :autoEmit="true"></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog :return-value.sync="item.Weight" large lazy persistent @save="saveItem({ID: item.ID, Weight: item.Weight})">
                          <div>{{ item.Weight | currency('', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input v-model="item.Weight" :decimal="1" label="Cân nặng (kg)" autofocus
                              :autoEmit="true"></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog :return-value.sync="item.Length" large lazy persistent @save="saveItem({ID: item.ID, Length: item.Length})">
                          <div>{{ item.Length | currency('', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input v-model="item.Length" :decimal="1" label="Chiều dài" autofocus
                              :autoEmit="true"></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog :return-value.sync="item.Width" large lazy persistent @save="saveItem({ID: item.ID, Width: item.Width})">
                          <div>{{ item.Width | currency('', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input v-model="item.Width" :decimal="1" label="Chiều rộng" autofocus
                              :autoEmit="true"></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog :return-value.sync="item.Height" large lazy persistent @save="saveItem({ID: item.ID, Height: item.Height})">
                          <div>{{ item.Height | currency('', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input v-model="item.Height" :decimal="1" label="Chiều cao" autofocus
                              :autoEmit="true"></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog :return-value.sync="item.FeeShip" large lazy persistent @save="saveItem({ID: item.ID, FeeShip: item.FeeShip})">
                          <div>{{ item.FeeShip | currency('¥', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input v-model="item.FeeShip" :decimal="1" label="Phí ship (运费)" autofocus
                              :autoEmit="true"></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog :return-value.sync="item.FeeFragileGoods" large lazy persistent
                          @save="saveItem({ID: item.ID, FeeFragileGoods: item.FeeFragileGoods})">
                          <div>{{ item.FeeFragileGoods | currency('¥', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input v-model="item.FeeFragileGoods" :decimal="1" label="Phí gia cố (加固费)" autofocus
                              :autoEmit="true"></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog :return-value.sync="item.FeeOther" large lazy persistent @save="saveItem({ID: item.ID, FeeOther: item.FeeOther})">
                          <div>{{ item.FeeOther | currency('¥', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input v-model="item.FeeOther" :decimal="1" label="Phí khác (其他)" autofocus
                              :autoEmit="true"></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td>{{ item.ReceivePlaceName }}</td>
                      <td class="truncate">
                        <v-edit-dialog :return-value.sync="item.StoreCNNote" large lazy persistent
                          @save="saveItem({ID: item.ID, StoreCNNote: item.StoreCNNote})">
                          <v-tooltip top absolute right offset-overflow max-width="250"
                            color="light-green lighten-5 black--text">
                            <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.StoreCNNote }}</span>
                            </template>
                            <span>{{ item.StoreCNNote }}</span>
                          </v-tooltip>
                          <template v-slot:input>
                            <v-textarea v-model="item.StoreCNNote" label="Ghi chú (备注)" autofocus
                              :autoEmit="true"></v-textarea>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on"> <v-icon medium>fa-bars</v-icon></v-btn>
                          </template>
                          <v-list>
                              <v-list-item @click="splitItem(item.ID)">
                                  <v-list-item-title>Tách kiện</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="deleteItem(item.ID)">
                                  <v-list-item-title>Xóa kiện</v-list-item-title>
                              </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <split-package
        :dialogSplitPackage="dialogSplitPackage"
        :currentItem="currentEditItem"
        v-on:closePopup="dialogSplitPackage = false"
    ></split-package>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import { getCurrentTime, playSound } from "@/commons/utils";
import { sendErrorNotice } from '@/commons/utils';
import split_package from "@/components/popups/split_package";
export default {
  name: "store-popup",
  components: {
    "split-package": split_package
  },
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 100;
    return {
      searchTerm: '',
      selectedUID: 0,
      selectedOrderType: 0,
      selectedOrderID: 0,
      currentOrderReceivePlaceID: 0,
      useBarcodeReader: true,
      nonameProduct: false,
      invertOrder: false,
      dialogSplitPackage: false,
      lastTransactionCode: '',
      warningsList: [],
      order_type_list: [
        { name: "Mua hộ", value: 0 },
        { name: "Ký gửi", value: 1 }
      ],
      currentItem: {
        TransactionCode: "",
        FeeShip: 0,
        NumberOfPack: this.isEcommerce ? 1 : 0
      },
      headers: [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Mã vận đơn (运单号)",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Mã VBI",
          value: "VbiCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Cảnh báo",
          sortable: false,
          filterable: false,
        },
        {
          text: "Số kiện (件数)",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cân nặng (kg)",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Chiều dài (cm)",
          value: "Length",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Chiều rộng (cm)",
          value: "Width",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Chiều cao (cm)",
          value: "Height",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí ship (运费)",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí gia cố (加固费)",
          value: "FeeFragileGoods",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí khác (其他)",
          value: "FeeOther",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Kho nhận",
          value: "ReceivePlaceName",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Ghi chú (备注)",
          value: "StoreCNNote"
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      currentTime: getCurrentTime(),
    };
  },
  props: ["dialogStoreManager", "isEcommerce"],
  watch: {
    dialogStoreManager() {
      if (this.dialogStoreManager) {
        this.getListData();
        this.currentItem.NumberOfPack = this.isEcommerce ? 1 : 0;
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    useBarcodeReader() {
      if (this.useBarcodeReader) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    items() {
      const lastItem = _.find(this.items, { 'TransactionCode': this.lastTransactionCode });
      if (lastItem && (lastItem.IsFragileGoods || lastItem.IsFoam || lastItem.IsCheck || lastItem.OrderGuarantee)) {
        playSound('/kien_can_luu_y.mp3')
      }
    }
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.listOfDay.data,
      total_rows: state => state.orderTransaction.listOfDay.total,
      customers: state => state.customer.master.data,
      stores: state => state.commons.stores,
      loading: state => state.orderTransaction.loading,
      currentEditItem: state => state.orderTransaction.selected,
    }),
    storeTQRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ2) == configs.ROLE_TYPE.StoreTQ2;
    },
    filterData() {
      return [
        {
          column: "StoreCNImportDate",
          value: getCurrentTime().toISOString().substr(0, 10),
          condition: "d_equal"
        },
        {
          column: "Status",
          value: configs.PACKAGE_STATUS_ENUM.DA_VE_KHO_GUI,
          condition: "equal"
        },
        {
          column: "IsEcommerce",
          value: this.isEcommerce ? 1 : 0,
          condition: "equal"
        }
      ];
    },
    filteredAndSortedCustomers() {
      if (!this.searchTerm) {
        return this.customers; // Hiển thị tất cả nếu không có search term
      }

      const normalizedSearchTerm = this.searchTerm.toLowerCase();

      // Bước 1: Lọc các mục theo điều kiện "bắt đầu bằng"
      let filtered = this.customers.filter(customer => {
        const normalizedCustomerName = customer.Username.toLowerCase();
        const customerIdString = String(customer.ID); // Chuyển ID sang chuỗi để tìm kiếm

        // Kiểm tra nếu tên hoặc ID bắt đầu bằng search term
        return `${customerIdString} - ${normalizedCustomerName}`.includes(normalizedSearchTerm);
      });

      // Bước 2: Sắp xếp các mục nếu search term khớp với điều kiện ưu tiên
      if (filtered.some(c => c.ID === Number(normalizedSearchTerm))) {
        // Tìm và loại bỏ mục ưu tiên khỏi mảng hiện tại
        const priorityItemIndex = filtered.findIndex(customer => customer.ID === Number(normalizedSearchTerm));
        let priorityItem = null;
        if (priorityItemIndex !== -1) {
          priorityItem = filtered.splice(priorityItemIndex, 1)[0]; // Loại bỏ và lấy item ra
        }

        // Nếu tìm thấy item ưu tiên, thêm nó vào đầu mảng
        if (priorityItem) {
          filtered.unshift(priorityItem);
        }
      }

      return filtered;
    },
    params() {
      var param = {
        pagination: {...this.pagination, sortBy: ["StoreCNImportDate"]},
        filter: this.filterData,
        quickFilter: [],
        fields: [
          "ID",
          "TransactionCode",
          "VbiCode",
          "Weight",
          "Length",
          "Width",
          "Height",
          "NumberOfPack",
          "FeeShip",
          "FeeFragileGoods",
          "FeeOther",
          "StoreCNNote",
          "ReceivePlaceName",
          "StoreCNImportDate"
        ]
      };
      param.fields.push("IsGuarantee");
      param.fields.push("GuaranteeType");
      param.fields.push("IsCheck");
      param.fields.push("CheckFeeType");
      param.fields.push("IsFragileGoods");
      param.fields.push("IsFoam");
      param.fields.push("IsWarning");
      return param;
    }
  },
  methods: {
    highlight(item) {
      if (!this.searchTerm) {
        // Nếu không có searchTerm, hiển thị Username gốc
        return `${item.ID} - ${item.Username}`;
      }

      const normalizedSearchTerm = this.searchTerm.toLowerCase();
      const itemUsername = item.Username;
      const itemID = String(item.ID); // Chuyển ID sang chuỗi để tìm kiếm

      // Tìm kiếm trong Username
      let highlightedUsername = itemUsername;
      let matchIndex = itemUsername.toLowerCase().indexOf(normalizedSearchTerm);
      if (matchIndex !== -1) {
        // Nếu tìm thấy trong Username, highlight phần đó
        highlightedUsername =
          itemUsername.substring(0, matchIndex) +
          `<strong class="highlight">${itemUsername.substring(matchIndex, matchIndex + this.searchTerm.length)}</strong>` +
          itemUsername.substring(matchIndex + this.searchTerm.length);
      }

      // Kiểm tra ID để xem có cần highlight ID không (chỉ highlight khi Username không khớp hoàn toàn)
      let highlightedID = itemID;
      let idMatchIndex = itemID.toLowerCase().indexOf(normalizedSearchTerm);

      if (idMatchIndex !== -1) {
        // Nếu tìm thấy trong ID, highlight phần đó
        highlightedID =
          itemID.substring(0, idMatchIndex) +
          `<strong class="highlight">${itemID.substring(idMatchIndex, idMatchIndex + this.searchTerm.length)}</strong>` +
          itemID.substring(idMatchIndex + this.searchTerm.length);
      }

      // Kết hợp ID và Username
      // Bạn có thể tùy chỉnh định dạng hiển thị ở đây (ví dụ: "ID - Username" hoặc "Username (ID)")
      // Dựa trên hình ảnh của bạn, định dạng là "ID - Username"
      // Chúng ta sẽ highlight phần phù hợp nhất (Username ưu tiên nếu cả hai đều có thể highlight)
      if (matchIndex !== -1) { // Ưu tiên highlight Username nếu tìm thấy
          return `${itemID} - ${highlightedUsername}`;
      } else if (idMatchIndex !== -1) { // Nếu không, highlight ID
          return `${highlightedID} - ${itemUsername}`;
      } else { // Nếu không có gì được highlight (ví dụ: filter theo startsWith nhưng highlight theo contains)
          return `${itemID} - ${itemUsername}`;
      }
    },
    closePopup() {
      this.$emit("closePopup");
    },
    deleteItem(id) {
      this.$emit("deleteItem", id);
    },
    splitItem(id) {
      this.$store.dispatch("orderTransaction/getDetail", id);
      this.dialogSplitPackage = true;
    },
    saveItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          ...item,
        },
        id: item.ID
      });
    },
    manualChanged() {
      if (this.currentItem.TransactionCode !== "" && !this.useBarcodeReader) {
        this.loadDetail();
      }
    },
    codeChanged() {
      this.selectedUID = 0;
      this.currentItem.UID = 0;
      if (this.currentItem.TransactionCode !== "" && this.useBarcodeReader) {
        this.loadDetail();
      }
    },
    loadDetail() {
      this.warningsList = [];
      this.currentItem.ID = null;
      this.currentItem.UID = null;
      this.currentItem.Username = null;
      this.currentItem.OrderID = null;
      this.currentItem.PackageType = null;
      this.currentItem.Weight = null;
      this.currentItem.Length = null;
      this.currentItem.Width = null;
      this.currentItem.Height = null;
      this.currentItem.FeeShip = 0;
      this.currentItem.FeeFragileGoods = null;
      this.currentItem.FeeOther = null;
      this.currentItem.StoreCNNote = null;
      this.selectedOrderID = 0;
      this.selectedUID = 0;
      this.selectedOrderType = 0;
      this.currentOrderReceivePlaceID = 0;
      this.$store.dispatch("orderTransaction/getDetailByCode", {
        TranCode: this.currentItem.TransactionCode,
        invertOrder: this.invertOrder,
      }).then(p => {
        if (p.Status >= 2) {
          sendErrorNotice('包裹已入库。');
          return;
        }
        if(this.isEcommerce && !p.IsEcommerce && !p.OrderID) {
          sendErrorNotice('提单不是电子订单。');
          return;
        }
        this.currentItem.ID = p.ID;
        this.currentItem.UID = p.UID;
        this.currentItem.Username = p.Username;
        this.currentItem.OrderID = p.OrderID;
        this.currentItem.PackageType = p.PackageType;
        this.currentItem.Weight = p.Weight;
        this.currentItem.Length = p.Length;
        this.currentItem.Width = p.Width;
        this.currentItem.Height = p.Height;
        this.currentItem.FeeShip = p.FeeShip;
        this.currentItem.FeeFragileGoods = p.FeeFragileGoods;
        this.currentItem.FeeOther = p.FeeOther;
        this.currentItem.StoreCNNote = p.StoreCNNote;
        this.selectedOrderID = p.OrderID;
        this.selectedUID = p.UID;
        this.selectedOrderType = p.PackageType;
        let soundFiles = [];
        let prefix = '_cn';
        if (p.IsFragileGoods) {
          soundFiles.push(`https://quanly.uniship.vn/sounds/dong_go${prefix}.mp3`)
          this.warningsList.push('打木架');
        }
        if (p.IsFoam) {
          soundFiles.push(`https://quanly.uniship.vn/sounds/bot_khi${prefix}.mp3`);
          this.warningsList.push('用气泡膜');
        }
        if (p.IsCheck) {
          soundFiles.push(`https://quanly.uniship.vn/sounds/kiem_dem${prefix}.mp3`);
          this.warningsList.push('理货');
        }
        if (p.IsGuarantee) {
          soundFiles.push(`https://quanly.uniship.vn/sounds/bao_hiem${prefix}.mp3`);
          this.warningsList.push('保险');
        }
        this.currentOrderReceivePlaceID = 0;
        if (p && p.OrderID && p.OrderReceivePlaceID > 0) {
          this.currentOrderReceivePlaceID = p.OrderReceivePlaceID;
          const store = _.find(this.stores, { ID: p.OrderReceivePlaceID });
          if (store && store.PlayOnSrc) {
            soundFiles.push(`${configs.SYSTEM_CONFIG.domain}/downloads/${store.SoundFile}`);
          }
        }
        else if (p.ReceivePlaceID > 0) {
          const store = _.find(this.stores, { ID: p.ReceivePlaceID });
          console.log(store);
          if (store && store.PlayOnSrc) {
            soundFiles.push(`${configs.SYSTEM_CONFIG.domain}/downloads/${store.SoundFile}`);
          }
        }
        if (p && p.SoundFiles) {
          const flagSounds = p.SoundFiles.split(',').map(s => s.trim()).filter(s => s.length > 0);
          for (const s of flagSounds) {
            if (s.startsWith('http://') || s.startsWith('https://')) {
              soundFiles.push(s);
            } else {
              soundFiles.push(`${configs.SYSTEM_CONFIG.domain}/downloads/${s}`);
            }
          }
        }
        if (p && p.FlagNames) {
          const flagNames = p.FlagNames.split(',').map(s => s.trim()).filter(s => s.length > 0);
          for (const name of flagNames) {
            this.warningsList.push(name);
          }
        }
        if (soundFiles.length > 0) {
          playSound(soundFiles.join(','));
        }
      });
    },
    async saveData() {
      if (this.currentItem.TransactionCode !== "" && (!this.selectedUID || this.currentItem.UID || await window.getApp.showConfirmation(`Bạn chắc chắn đơn này là mã khách hàng <b style="color:red; font-size:20px">${this.selectedUID}</b> không?`))) {
        this.appendTransactionCode();
      }
    },
    getCustomerText(item) {
      return `${item.ID} - ${item.Username}`
    },
    findUsername(uid) {
      // Kiểm tra xem customers đã có dữ liệu chưa
      if (!this.customers || this.customers.length === 0) {
        console.warn("Customers data is not available yet.");
        return ''; // Hoặc giá trị mặc định khác
      }
      const customer = _.find(this.customers, { 'ID': uid });
      return customer ? customer.Username : '';
    },
    appendTransactionCode: _.debounce(
      function () {
        if (!this.nonameProduct && !this.selectedUID && !this.selectedOrderID) {
          sendErrorNotice('请填写完整客户编码或订单编号');
          return;
        }
        if(this.isEcommerce && this.currentItem.NumberOfPack < 1) {
          sendErrorNotice('电商订单只能有一个包裹，请检查');
          return;
        }
        if(!this.isEcommerce && !this.currentItem.NumberOfPack) {
          sendErrorNotice('包裹数量必须大于 0');
          return;
        }
        // Khớp thông tin đơn hàng với mã vận đơn
        if(!this.currentItem.UID) {
          this.currentItem.StoreUID = this.selectedUID;
        }
        if(!this.currentItem.OrderID) {
          this.currentItem.StoreOrderID = this.selectedOrderID;
        }
        // this.currentItem.Username = this.findUsername(this.selectedUID);
        this.currentItem.PackageType = this.selectedOrderType;
        this.lastTransactionCode = this.currentItem.TransactionCode;
        this.$store.dispatch("orderTransaction/setDetail", {
          data: {
            ...this.currentItem,
            IsEcommerce: this.isEcommerce ? 1 : 0,
            Status: configs.PACKAGE_STATUS_ENUM.DA_VE_KHO_GUI,
            TransactionView: 'store_cn_popup',
            InvertOrder: this.invertOrder
          },
          param: this.params
        }).then((ret) => {
          let soundFiles = [];
          if (this.currentOrderReceivePlaceID) {
            const store = _.find(this.stores, { ID: this.currentOrderReceivePlaceID });
            if (store && store.PlayOnSrc) {
              soundFiles.push(`${configs.SYSTEM_CONFIG.domain}/downloads/${store.SoundFile}`);
            }
          }
          else if (ret && !ret.OrderID && ret.StoreReceivePlaceID > 0) {
            const store = _.find(this.stores, { ID: ret.StoreReceivePlaceID });
            if (store && store.PlayOnSrc) {
              soundFiles.push(`${configs.SYSTEM_CONFIG.domain}/downloads/${store.SoundFile}`);
            }
          }
          else if (ret && ret.ReceivePlaceID > 0) {
            const store = _.find(this.stores, { ID: ret.ReceivePlaceID });
            if (store && store.PlayOnSrc) {
              soundFiles.push(`${configs.SYSTEM_CONFIG.domain}/downloads/${store.SoundFile}`);
            }
          }
          if (ret && ret.SoundFiles) {
            const flagSounds = ret.SoundFiles.split(',').map(s => s.trim()).filter(s => s.length > 0);
            for (const s of flagSounds) {
              if (s.startsWith('http://') || s.startsWith('https://')) {
                soundFiles.push(s);
              } else {
                soundFiles.push(`${configs.SYSTEM_CONFIG.domain}/downloads/${s}`);
              }
            }
          }
          if (soundFiles.length > 0) {
            playSound(soundFiles.join(','));
          }
        });
        this.currentItem = {
          TransactionCode: "",
          FeeShip: 0,
          NumberOfPack: this.isEcommerce ? 1 : 0,
        };
        this.selectedOrderID = 0;
        this.selectedUID = 0;
        this.selectedOrderType = null;
        this.$nextTick(() => this.$refs.trancode.focus());
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    getListData() {
      this.$store.dispatch("orderTransaction/getListOfDay", this.params);
    },
    customAutocompleteFilter(item, queryText, itemText) {
      // Đảm bảo itemText và queryText là chuỗi và chuyển đổi sang chữ thường để so sánh không phân biệt chữ hoa chữ thường.
      // Kiểm tra null/undefined cho itemText và queryText để tránh lỗi
      const normalizedQuery = (queryText || '').toLowerCase();
      const normalizedItemText = (itemText || '').toLowerCase();
      // Nếu queryText rỗng, hiển thị tất cả các mục
      if (!normalizedQuery) {
        return true;
      }
      // Kiểm tra xem itemText có bắt đầu bằng queryText hay không
      return item.ID.toString() === normalizedQuery || normalizedItemText.startsWith(normalizedQuery);
    },
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.getListData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getListData);
  }
};
</script>
<style>
/* Thêm CSS cho phần highlight */
.highlight {
  font-weight: bold;
  /* Bạn có thể chọn màu nền hoặc màu chữ khác */
  color: #1976D2; /* Màu xanh của Vuetify */
  /* background-color: yellow; */
}
</style>